import * as Common from "../../commons/common"
import moment from 'moment';

export class Examinee {
  id: number
  sheet_id: number
  student_no: number
  student_no_character: string
  student_name: string
  absent_flg: boolean
  result_image_created: boolean
  score: number
  saitenCompletedFieldCount: number
  checked: boolean = false
  checkedCache: boolean = false
  sheetActivities: SheetActivity[] = new Array<SheetActivity>()
  fieldActivities: FieldActivity[] = new Array<FieldActivity>()
  base64ScanImages: string[] = new Array<string>();
  base64ResultImages: string[] = new Array<string>();
  saiten_completed: boolean = false

  constructor(examinee: any, sheetActivities: SheetActivity[], fieldActivities: FieldActivity[], sheet_type: number){
    this.id = examinee.id;
    this.sheet_id = examinee.sheet_id;
    this.student_no = examinee.student_no;
    this.student_no_character = examinee.student_no_character;
    this.student_name = examinee.student_name;
    this.absent_flg = examinee.absent_flg;
    this.result_image_created = examinee.result_image_created;
    this.sheetActivities = sheetActivities.filter(x => x.student_id == this.student_no);
    this.sheetActivities.forEach(x => {
      this.fieldActivities = this.fieldActivities.concat(fieldActivities.filter(y => y.sheet_activity_id == x.id));
    });
    this.fieldActivities = this.fieldActivities.sort((a, b) => a.sheet_field_id - b.sheet_field_id);
    this.saitenCompletedFieldCount = this.fieldActivities.filter(x => x.saiten_completed).length;
    this.saiten_completed = this.fieldActivities.length == this.saitenCompletedFieldCount;

    // 得点設定 欠席者は得点ソート用に-1を設定（０点の生徒と欠席生徒を区別するため）
    this.score = Common.sumArray(this.fieldActivities.map(x => x.score == null ? 0 : x.score));
    this.score = this.absent_flg ? -1 : this.score;

    if(sheet_type == Common.SheetTypeEnum.Homework){
      this.checked = examinee.result_published;
      this.checkedCache = this.checked;
    }
  }
}

export class SheetActivity {
  id: number
  student_id: number
  score: number
  saiten_completed: boolean
  page: number
  reviewTexts: ReviewText[] = new Array<ReviewText>()
  reviewImages: ReviewImage[] = new Array<ReviewImage>()
  idx: number = 0
  base64Canvas: string = null
  is_canvas_drawed: boolean = false

  constructor(sheetActivity: any){
    this.id = sheetActivity.id;
    this.student_id = sheetActivity.student_id;
    this.score = sheetActivity.score;
    this.saiten_completed = sheetActivity.saiten_completed;
    this.page = sheetActivity.page
  }
}

export class FieldActivity {
  id: number
  sheet_activity_id: number
  sheet_field_id: number
  score: number
  correct_state: number
  saiten_completed: boolean
  saitenStickyNotes: SaitenStickyNote[]
  
  constructor(fieldActivity: any, saitenStickyNotes: SaitenStickyNote[]){
    this.id = fieldActivity.id;
    this.sheet_activity_id = fieldActivity.sheet_activity_id;
    this.sheet_field_id = fieldActivity.sheet_field_id;
    this.score = fieldActivity.score;
    this.correct_state = fieldActivity.correct_state;
    this.saiten_completed = fieldActivity.saiten_completed;
    this.saitenStickyNotes = saitenStickyNotes.filter(x => x.field_activity_id == fieldActivity.id);
  }
}

export class Sheet {
  sheet_group_key: number
  grade: number
  room_name: string
  name: string
  curriculum_id: number
  subject_name: string
  subject_code: string
  exec_date: string
  allot: number
  page_count: number
  sheet_type: number
  approval_flg: boolean
  approved_user_name: string
  approved_at: string
  verify_count: number
  is_digital_paper: boolean
  is_mask_student_info: boolean
  imageWidth: number
  imageHeight: number

  constructor(sheet: any, approved_user_name: string){
    this.sheet_group_key = sheet.sheet_group_key;
    this.grade = sheet.grade;
    this.room_name = sheet.room_name;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.subject_code = sheet.subject_code;
    this.exec_date = sheet.exec_date;
    this.allot = sheet.allot;
    this.page_count = sheet.page_count;
    this.sheet_type = sheet.sheet_type;
    this.approval_flg = sheet.approval_flg;
    this.approved_user_name = approved_user_name;
    this.approved_at =  sheet.approved_at ? moment(sheet.approved_at).format('Y年M月D日') : "";
    this.verify_count = sheet.verify_count;
    this.is_digital_paper = sheet.is_digital_paper;
    this.is_mask_student_info = sheet.is_mask_student_info;
    this.imageWidth = sheet.correct_image_size[0];
    this.imageHeight = sheet.correct_image_size[1];
  }
}

export class SheetField {
  id: number
  part1: string
  part2: string
  part3: string
  allot: number
  allotCache: number
  scoreAverage: number
  scoreRate: number
  feldActivities: FieldActivity[] = new Array<FieldActivity>()
  isSaitenCompleted: boolean
  firstSaitenCompletedCount: number
  secondSaitenCompletedCount: number
  thirdSaitenCompletedCount: number
  second_scorers_id: number | null
  third_scorers_id: number | null
  first_user_name: string | null
  second_user_name: string | null
  third_user_name: string | null
  scoring_type: number | null
  mark_count: number

  constructor(sheetField: any, fieldActivities: FieldActivity[], sheet: Sheet, isCompare: boolean){
    this.id = sheetField.id;
    this.part1 = sheetField.part1;
    this.part2 = sheetField.part2;
    this.part3 = sheetField.part3;
    this.allot = sheetField.allot;
    this.allotCache = sheetField.allot;
    this.feldActivities = fieldActivities.filter(x => x.sheet_field_id == this.id);
    const totalScore: number = Common.sumArray(this.feldActivities.map(x => x.score == null ? 0 : x.score));
    this.scoreAverage = Number((totalScore / this.feldActivities.length).toFixed(1));
    this.scoreRate = Math.round(totalScore / (this.allot * this.feldActivities.length) * 100);
    this.second_scorers_id = sheetField.second_scorers_id;
    this.third_scorers_id = sheetField.third_scorers_id; 
    this.firstSaitenCompletedCount = this.feldActivities.filter(x => x.saiten_completed).length;
    this.secondSaitenCompletedCount = this.second_scorers_id == null ? 0 : this.firstSaitenCompletedCount;
    this.thirdSaitenCompletedCount = this.third_scorers_id == null ? 0 : this.firstSaitenCompletedCount;
    this.first_user_name = getScorersName(sheetField.first_scorers_id, sheetField.first_user_name, isCompare);
    this.second_user_name = getScorersName(sheetField.second_scorers_id, sheetField.second_user_name, isCompare);
    this.third_user_name = getScorersName(sheetField.third_scorers_id, sheetField.third_user_name, isCompare);
    this.scoring_type = sheetField.scoring_type;
    this.mark_count = sheetField.mark_count;

    if(sheet.verify_count == 1){
      this.isSaitenCompleted = this.firstSaitenCompletedCount == this.feldActivities.length;
    }else if(sheet.verify_count == 2){
      this.isSaitenCompleted = this.secondSaitenCompletedCount == this.feldActivities.length;
    }else if(sheet.verify_count == 3){
      this.isSaitenCompleted = this.thirdSaitenCompletedCount == this.feldActivities.length;
    }
  }
}

export const getScorersName = (scorers_id: number, user_name: string, isCompare: boolean) => {
  let rtn = "";
  if(scorers_id == -1){
    // -1が設定されているのは入試ベリファイのマーク認識とコンペア最終採点の照合一致の2ケース
    rtn = isCompare ? "自動採点" : "マーク認識";
  }else if(scorers_id && !user_name){
    rtn = "削除されたユーザー"
  }else{
    rtn = user_name;
  }
  return rtn;
}

export class ScoreOption {
  value: number
  text: string

  constructor(value: number, text: string){
    this.value = value;
    this.text = text;
  }
}

export class ReviewText {
  id: number
  sheet_activity_id: number
  idx: number
  direction: number
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_text: string = null
  is_active: boolean = false
  review_type: number = null
}

export class ReviewImage {
  id: number
  sheet_activity_id: number
  idx: number
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_image: string = null
  is_active: boolean = false
  review_type: number = null
}

export enum ReviewTypeEnum {
  Text = 1,
  Image = 2,
}

export class SaitenStickyNote {
  id: number
  field_activity_id: number
  comment: string
  color: string
  is_show_popover: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.field_activity_id = x.field_activity_id;
    this.comment = x.comment;
    this.color = x.color;
  }
}
